import AxiosCustom from "../../../common/components/apiConfig";

export const insert_pod_paya_payment = (data) => {
  let config = { url: "insert_request" };

  let _data = {
    table: "payment",
    method_type: "insert_pod_paya_payment",
    data: {
      ...data,
    },
  };

  return AxiosCustom(config, _data);
};
